// extracted by mini-css-extract-plugin
export default {"slidesList":"SlidesList_slidesList__53ebJ","slidesContainer":"SlidesList_slidesContainer__v-iYt"};